export const PlantDesignDetailsPage = {
  common: {
    plantType: {
      label: 'Type of plant design',
    },
    manufacturer: {
      label: 'Manufacturer (if needed)',
    },
    modelNameOrNumber: {
      label: 'Model',
      helpMessage: 'Enter the identification/ model name or number',
    },
    registrationTypes: {
      new: {
        value: 'new',
        label: 'New plant design',
        clarify: 'Has not been previously registered',
        yearLabel: 'Year of design (if known)',
      },
      alteration: {
        value: 'alteration',
        label: 'Plant design alteration',
        clarify: 'Design changes that affect health and Safety (eg. new control measures)',
        yearLabel: 'Year of design alteration (if known)',
      },
      corrections: {
        value: 'corrections',
        label: 'Corrections',
        clarify: 'Fixing a mistake (eg. error on a registration certificate)',
      },
    },
    registrationTypeLabel: 'Type of registration',
  },
  designAlteration: {
    reasonForAlteration: {
      label: 'Reason for alteration',
      helpMessage: 'Explain why you are altering the design and what will change',
    },
    registrationNumber: {
      label: 'Current design registration number',
    },
    registeredLocation: {
      label: 'Where was the design registered?',
      helpMessage: 'Select an Australian state',
    },
  },

  boiler: {
    boilerType: {
      label: 'Type of boiler',
    },
    hazardLevel: {
      label: 'Hazard level',
    },
    minVolume: {
      label: 'Minimum volume',
      suffix: 'L',
    },
    maxVolume: {
      label: 'Maximum volume',
      suffix: 'L',
    },
    designTemperature: {
      label: 'Design temperature',
      suffix: '&deg;C',
    },
    designPressure: {
      label: 'Design pressure',
      suffix: 'kPag',
    },
    outputUnit: {
      label: 'Output',
    },
  },
  pressureVessel: {
    typeOfPressureVesel: {
      label: 'Type of pressure vessel',
    },
    numberOfChambers: {
      label: 'How many chambers does the pressure vessel have?',
    },
    hazardLevel: {
      label: 'Pressure vessel hazard level',
      helpMessage: 'Pressure vessel hazard level according to AS 4343',
    },
    minVolume: {
      label: 'Minimum volume',
      suffix: 'L',
    },
    maxVolume: {
      label: 'Maximum volume',
      suffix: 'L',
    },
    designPressure: {
      label: 'Design pressure',
      suffix: 'kPag',
    },
    chamberContents: {
      label: 'Please describe the chambers contents',
    },
    designTemp: {
      label: 'Design temperatures',
    },
    minDesignTemp: {
      label: 'Minimum design temperature', // This is only used in the DesignDetailsReview.js
      suffix: 'Min &deg;C',
    },
    maxDesignTemp: {
      label: 'Maximum design temperature', // This is only used in the DesignDetailsReview.js
      suffix: 'Max &deg;C',
    },
  },
  gasCylinder: {
    materialType: {
      label: 'Material Type',
    },
    otherMaterialType: {
      label: 'Please describe the material type',
    },
    constructionType: {
      label: 'Construction type',
    },
    minVolume: {
      label: 'Minimum volume',
      suffix: 'L',
    },
    maxVolume: {
      label: 'Maximum volume',
      suffix: 'L',
    },
    testPressure: {
      label: 'Test pressure',
    },
    contents: {
      label: 'Contents',
    },
  },
  lift: {
    typeOfLift: {
      label: 'Type of lift',
    },
    driveSuspensionType: {
      label: 'Drive and suspension type',
    },
    isMRLLift: {
      label: 'Is this a Machine-Room-Less (MRL) Lift?',
    },
    carriageType: {
      label: 'Carriage type',
    },
    controlType: {
      label: 'Control type',
    },
    maxSpeed: {
      label: 'Maximum rated speed',
      suffix: 'm/s',
    },
    maxRatedLoad: {
      label: 'Rated load',
      suffix: 'Kg',
    },
    maxPassengers: {
      label: 'Maximum number of passengers',
    },
    maxTravel: {
      label: 'Maximum travel',
      suffix: 'm',
    },
  },
  escalator: {
    maxSpeed: {
      label: 'Maximum rated speed',
      suffix: 'm/s',
    },
    maxAngle: {
      label: 'Maximum angle of incline',
      suffix: 'degrees',
    },
    maxTravel: {
      label: 'Maximum travel',
      suffix: 'm',
    },
    maxWidth: {
      label: 'Maximum width',
      suffix: 'm',
    },
    maxPassengers: {
      label: 'Maximum number of passengers per hour',
    },
  },
  movingWalkway: {
    maxSpeed: {
      label: 'Maximum rated speed',
      suffix: 'm/s',
    },
    maxAngle: {
      label: 'Maximum angle of incline',
      suffix: 'degrees',
    },
    maxTravel: {
      label: 'Maximum travel',
      suffix: 'm',
    },
    maxWidth: {
      label: 'Maximum width',
      suffix: 'm',
    },
    maxPassengers: {
      label: 'Maximum number of passengers per hour',
    },
  },
  hoistWithPlatformMovement: {
    hoistType: {
      label: 'Hoist type',
    },
    otherHoistType: {
      label: 'Please describe',
    },
    maxRatedCapacity: {
      label: 'Maximum rated capacity',
      suffix: 'kg',
    },
    maxFreestandingHeight: {
      label: 'Maximum freestanding height',
      suffix: 'm',
    },
    maxTravel: {
      label: 'Maximum travel',
      suffix: 'm',
    },
    maxVerticalTravellingSpeed: {
      label: 'Maximum vertical travelling speed',
      suffix: 'm/s',
    },
  },
  vehicleHoist: {
    hoistType: {
      label: 'Hoist type',
    },
    otherHoistType: {
      label: 'Please describe',
    },
    driveType: {
      label: 'Drive type',
    },
    otherDriveType: {
      label: 'Please describe',
    },
    maxRatedCapacity: {
      label: 'Maximum rated capacity',
      suffix: 'kg',
    },
    maxTravel: {
      label: 'Maximum travel',
      suffix: 'm',
    },
    maxHoistingSpeed: {
      label: 'Maximum hoisting speed',
      suffix: 'm/s',
    },
  },
  mastClimbingWorkPlatform: {
    mastType: {
      label: 'Mast type',
    },
    baseType: {
      label: 'Type of base',
    },
    maxRatedCapacity: {
      label: 'Maximum rated capacity',
      suffix: 'kg',
    },
    maxWorkingHeight: {
      label: 'Maximum working height',
      suffix: 'm',
    },
    maxFreeStandingHeight: {
      label: 'Maximum freestanding height',
      suffix: 'm',
    },
    maxWindVelocityInService: {
      label: 'Maximum wind velocity in service',
      suffix: 'm/s',
    },
    maxVerticalTravelSpeed: {
      label: 'Maximum vertical travel speed',
      suffix: 'm/s',
    },
  },
  buildingMaintenanceUnit: {
    safeWorkingLoad: {
      label: 'Safe working load of the platform',
      suffix: 'kg',
    },
    maxWorkingHeight: {
      label: 'Maximum working height',
      suffix: 'm',
    },
  },
  boomTypeElevatingWorkPlatform: {
    maxRatedCapacity: {
      label: 'Maximum rated capacity ',
      suffix: 'kg',
    },
    designUse: {
      label: 'Is it designed for indoor or indoor and outdoor?',
    },
    maxChassisInclination: {
      label: 'Maximum chassis inclination ',
      suffix: 'degrees',
    },
    maxRatedWindVelocity: {
      label: 'Maximum rated wind velocity for outdoor use ',
      suffix: 'm/s',
    },
    insulationType: {
      label: 'Non-insulated or insulated',
    },
    insulationRating: {
      label: 'Insulation rating ',
      suffix: 'kv',
    },
    maxPlatformHeight: {
      label: 'Maximum platform height ',
      suffix: 'm',
      helpText: 'Vertical distance from the supporting surface to floor of work platform',
    },
    maxBoomLength: {
      label: 'Maximum boom length ',
      suffix: 'm',
      helpText: 'Horizontal distance from the centre point of boom’s rotation to outer edge of work platform',
    },
  },
  towerCrane: {
    towerCraneType: {
      label: 'Type of tower crane',
      suffix: 't',
    },
    maxRatedCapacity: {
      label: 'Maximum rated capacity',
      suffix: 't',
    },
    maxRadius: {
      label: 'Maximum radius',
      suffix: 'm',
    },
    maxHeight: {
      label: 'Maximum height',
      suffix: 'm',
    },
  },
  mobileCrane: {
    mobileCraneType: {
      label: 'Type of mobile crane',
    },
    otherTypeOfMobileCrane: {
      label: 'Other (please describe)',
    },
    modelDetails: {
      label: 'Carrier make and model details',
    },
    maxRatedCapacity: {
      label: 'Maximum rated capacity',
      suffix: 't',
    },
    maxRadius: {
      label: 'Designer’s maximum radius',
      suffix: 'm',
    },
  },
  bridgeCrane: {
    bridgeCraneType: {
      label: 'Type of bridge crane',
    },
    maxSpanOfBridge: {
      label: 'Maximum span of bridge ',
      suffix: 'm',
    },
    maxHeightOfBridge: {
      label: 'Maximum height of bridge above ground',
      suffix: 'm',
    },
    craneControlType: {
      label: 'Crane control type',
    },
  },
  gantryCrane: {
    grantryCraneType: {
      label: 'Type of gantry crane',
    },
    maxSpanOfBridge: {
      label: 'Maximum span of bridge ',
      suffix: 'm',
    },
    maxHeightOfBridge: {
      label: 'Maximum height of bridge above ground',
      suffix: 'm',
    },
    craneControlType: {
      label: 'Crane control type',
    },
  },
  suspendedWorkbox: {
    maxRatedCapacity: {
      label: 'Maximum rated capacity',
      suffix: 'kg',
    },
    maxPersons: {
      label: 'Maximum number of persons',
    },
    tareMass: {
      label: 'Tare mass',
      suffix: 'kg',
    },
    boxLength: {
      label: 'Length of box',
      suffix: 'm',
    },
    boxWidth: {
      label: 'Width of box',
      suffix: 'mm',
    },
    boxHeight: {
      label: 'Height of box',
      suffix: 'm',
    },
    isForFirstAidOnly: {
      label: 'This suspended workbox is for first aid only',
    },
  },
  prefabricatedScaffolding: {
    prefabricatedScaffoldingType: {
      label: 'Type of prefabricated scaffold ',
    },
    maxPlatformDutyRating: {
      label: 'Maximum platform duty rating',
    },
    material: {
      label: 'Material used to make the standards',
      helpText: 'Vertical load bearing members',
    },
    otherMaterial: {
      label: 'Please describe the material',
    },
    outerDiameter: {
      label: 'Outer diameter',
      suffix: 'mm',
    },
    wallThickness: {
      label: 'Wall thickness',
      suffix: 'mm',
    },
    grade: {
      label: 'Grade',
      suffix: 'MPa',
    },
    maxPlatformHeight: {
      label: 'Maximum platform height',
      suffix: 'm',
    },
    frameWidth: {
      label: 'Frame width',
      suffix: 'm',
    },
    frameHeight: {
      label: 'Frame height',
      suffix: 'm',
    },
    maxDesignHeight: {
      label: 'Maximum design height (at maximum platform duty rating)',
      suffix: 'm',
    },
    maxFullyPlankedPlatformLevels: {
      label: 'Maximum number of fully planked platform levels at maximum working design height',
    },
    isLoadedSimultaneously: {
      label: 'At maximum design height the designer allows multiple platform levels to be loaded simultaneously',
    },
  },
  concretePlacingBoom: {
    concretePlacingBoomType: {
      label: 'Type of concrete placing boom',
    },
    maxBoomLength: {
      label: 'Maximum boom length',
      suffix: 'm',
      helpMessage: 'Distance from centre of the boom slewing point to tip of boom with boom in a horizontal position',
    },
    maxBoomHeight: {
      label: 'Maximum boom height',
      suffix: 'm',
      helpMessage: 'Distance from the ground to top of boom with the boom at maximum elevation',
    },
  },
  amusementDevice: {
    deviceName: {
      label: 'Name or description of amusement device',
    },
    deviceClass: {
      label: 'Please select the class of device',
      helpText: 'In accordance with AS 3543 Part 1',
    },
    mobilityType: {
      label: 'Is it fixed or mobile?',
    },
    deviceType: {
      label: 'Type of amusmement device',
    },
    otherDeviceType: {
      label: 'Please describe the type of amusement device)',
    },
    operatingPower: {
      label: 'Operating power',
    },
    otherOperatingPower: {
      label: 'Please Describe the operating type',
    },
    maxSpeed: {
      label: 'Maximum speed of patron',
      suffix: 'm/s',
    },
    maxAcceleration: {
      label: 'Maximum acceleration',
      suffix: 'm/s²',
    },
    maxResolvingSpeed: {
      label: 'Maximum revolving speed (if applicable)',
      suffix: 'rpm',
    },
    maxPatronHeight: {
      label: 'Maximum height attained by patron',
      suffix: 'cm',
    },
    maxPatronSupportUnits: {
      label: 'Maximum number of patron support units',
    },
    maxAdultPatronsPerSupport: {
      label: 'Maximum number of adult patrons per support',
    },
    maxChildPatronsPerSupport: {
      label: 'Maximum number of child patrons per support (if known)',
    },
    minAgeUnaccompaniedPatron: {
      label: 'Minimum age of unaccompanied patron',
      suffix: 'years',
    },
    minAgeAccompaniedPatron: {
      label: 'Minimum age of accompanied patron (optional)',
      suffix: 'years',
    },
    maxHeightAttainedByPatron: {
      label: 'Maximum height attained by patron',
      suffix: 'cm',
    },
    minPatronHeight: {
      label: 'Minimum patron height (if applicable)',
      suffix: 'cm',
    },
    electricalInstallation: {
      label: 'Does the device have an electrical installation?',
    },
    intrinsicSafety: {
      label: 'Intrinsic safety',
    },
  },
  passengerRopeway: {
    passengerRopewayType: {
      label: 'Type of passenger ropeway',
    },
    carrierType: {
      label: 'Type of carrier',
    },
    maxNumberOfCarriers: {
      label: 'Maximum number of carriers',
    },
    numberOfCompressionTensionTowers: {
      label: 'Number of compression tension towers',
    },
    maxNumberOfPersons: {
      label: 'Maximum number of persons (if known)',
    },
    maxHeightOfCarrierAboveSurface: {
      label: 'Maximum height of carrier above ground or other surface (if known)',
      suffix: 'm',
    },
    maxNumberOfPersonPerCarrier: {
      label: 'Maximum number of persons per carrier',
    },
    numberOfTowers: {
      label: 'Number of towers',
    },
    travelDistanceSingleDirection: {
      label: 'Travel distance, single direction (if known)',
      suffix: 'm',
    },
    numberOfFacilities: {
      label: 'Number of load/unload facilities',
    },
  },
};
